import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const AuthGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  if (authService.isLoggedIn() && !authService.isTokenExpired(authService.getToken() || '')) {
    return true;
  }
  window.location.href = '/login';
  return false;
};

export const LoginGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isLoggedIn() && !authService.isTokenExpired(authService.getToken() || '')) {
    router.navigate(['/VenderManagement']);
    return false;
  }
  return true;
};
